import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import { Tabs } from "@shared/ui/tabs";
import { History, Plus, Settings } from "lucide-react";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ServiceOrderHistory from "../history/landing/history";
import { ServiceOrdersTab } from "../management/landing/management";

interface LandingProps {
  // Add your props here
}

export const Landing: React.FC<LandingProps> = () => {
  const navigate = useNavigate();
  const tabComponents = useMemo(() => {
    return {
      management: {
        label: "Service Orders Management",
        icon: <Settings className="h-4 w-4" />,
        component: <ServiceOrdersTab key="service-orders-management" />,
      },
      history: {
        label: "Service Orders History",
        icon: <History className="h-4 w-4" />,
        component: <ServiceOrderHistory key="service-orders-history" />,
      },
    };
  }, []);

  return (
    <div className="p-4">
      <div className="flex justify-between space-x-4 pb-4">
        <PageHeader
          title="Service Orders"
          subtitle="Manage and track service orders with comprehensive history tracking"
        />
        <Button
          size="sm"
          onClick={() => navigate("/ax/service-order/landing/create")}
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Order
        </Button>
      </div>
      <Tabs
        defaultValue="management"
        className="space-y-6"
        urlMapping={{
          management: "management",
          history: "history",
        }}
        idPrefix="service-orders"
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 p-1"
      />
    </div>
  );
};
